import React, { useRef, useEffect } from 'react';
import CurrentName from "./CurrentName";


const EditField = ({
    name,
    label,
    withLineBreak=false,
    lineBreakInCurrentName,
    formValue,
    currValue,
    isPrice=false,
    activeField,
    inputRef=false, 
    children,
    setActiveField
}) => {

    const editing = (activeField === name);

    const closeInput = () => {
        setActiveField('');
    }

    const checkEnter = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            closeInput();
        }
    }

    if(inputRef) {
        useEffect(() => {
            const inp = inputRef.current;

            inp.addEventListener('keypress', checkEnter);
            inp.addEventListener('blur', closeInput);
            
            return () => {
                inp.removeEventListener('keypress', checkEnter);
                inp.removeEventListener('blur', closeInput);
            
            };
    
        }, [editing]);
    }

    return (
        <div className='text-value-field'>
            {label && <label htmlFor={name} className='text-small-light'>{label + ':'}</label>}
            {withLineBreak && <br />}
            <span className='editing-wrapper'>
                <span className={'editing-element' + (editing ? ' hidden' : '')}  onClick={()=> setActiveField(name)}>
                    <CurrentName
                        lineBreakInCurrentName={lineBreakInCurrentName}
                        formValue={formValue}
                        currValue={currValue}
                        formName={formValue}
                        currName={currValue}
                        isPrice={isPrice}
                    />
                </span>
                <span className={'editing-element' + (!editing ? ' hidden' : '')}>
                    {children}
                </span>
            </span>
        </div>
    )
}

export default EditField;